import { defineStore } from 'pinia';
import { type RoleType, type UserState } from './types';
import { $fetch } from '@/utils/fetch';
import { ref } from 'vue';
import { setToken, clearToken, getToken, buildRedirectUri } from '@/utils/auth';

const useUserStore = defineStore('user', () => {
  const getInitUser = (): UserState => ({
    id: undefined,
    photo: undefined,
    username: undefined,
    nickname: undefined,
    email: undefined,
    roles: [],
  });

  const user = ref<UserState>(getInitUser());

  const setInfo = (partial: Partial<UserState>) => {
    user.value = { ...user.value, ...partial };
  }

  const resetInfo = () => {
    user.value = getInitUser();
  }

  // Get user's information
  const fetchInfo = async () => {
    if (import.meta.env.VITE_MOCK_LOGIN === 'yes') {
      setInfo({
        id: '1',
        photo: 'https://lf1-xgcdn-tos.pstatp.com/obj/vcloud/vadmin/start.8e0e4855ee346a46ccff8ff3e24db27b.png',
        email: 'wangliqun@email.com',
        username: 'wangliqun',
        nickname: 'wlq',
        roles: ['admin'],
      });

      return {
        isSuccess: true,
        code: 200,
      };
    }
    else {
      const { isSuccess, data, msg, code } = await $fetch<{
        user_id: number;
        login: string;
        name: string;
        avatar_url: string;
        role: string;
      }>('/api/auth/userinfo', {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      });

      if (isSuccess && data) {
        const roles: RoleType[] = data.role ? [data.role as RoleType] : [];

        if (!roles.length) {
          return {
            isSuccess: false,
            msg: '无权访问',
            code: 403,
          };
        }

        setInfo({
          id: data.user_id !== undefined ? String(data.user_id) : undefined,
          photo: data.avatar_url,
          username: data.login,
          nickname: data.name,
          roles,
        });
      }

      return { isSuccess, msg, code: Number(code) };
    }
  }

  // Login
  const login = async (code: string, from = '/') => {
    const { isSuccess, data, msg } = await $fetch<{ token: string }>('/api/auth/token', {
      errorMessage: false,
      data: {
        redirect_uri: buildRedirectUri(from),
        code,
      },
    });

    if (isSuccess && data) {
      setToken(data.token);
    }
    else {
      clearToken();
    }

    return { isSuccess, msg };
  }

  return { user, setInfo, resetInfo, fetchInfo, login };
});

export default useUserStore;
